export default __webpack_public_path__ + "static/rebecca balakovits-1e6d8e32875532c54943b1dfa6c169ce.png";